import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export const CallToAction = () => {
  return <section className="w-full bg-gradient-to-b from-white to-pink-50 py-12 px-4 md:px-8" data-id="element-80">
      <div className="max-w-5xl mx-auto" data-id="element-81">
        <div className="bg-white rounded-lg shadow-lg p-6 md:p-8 border-t-4 border-pink-500" data-id="element-82">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-83">
            Jeśli czytasz to i płaczesz...
          </h2>
          <p className="text-gray-700 mb-4" data-id="element-84">
            To znaczy, że czas najwyższy, żebyś zrobiła coś dla siebie. Nie za
            tydzień. Nie "jak będzie spokojniej". Teraz.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-85">
            Bo prawda jest taka - nigdy nie będzie idealnego momentu. Zawsze
            będzie coś pilnego, ktoś będzie czegoś potrzebował, zawsze znajdzie
            się wymówka.
          </p>
          <p className="text-gray-700 mb-6" data-id="element-86">
            Ale Ty też jesteś ważna. Twoje zdrowie psychiczne jest ważne. Twój
            spokój jest ważny.
          </p>
          <div className="bg-gray-50 rounded-lg p-6 my-6" data-id="element-87">
            <h3 className="text-lg font-bold text-gray-800 mb-4" data-id="element-88">
              I wiesz co? 27,99 zł to mniej niż:
            </h3>
            <div className="space-y-3" data-id="element-89">
              <div className="flex items-start" data-id="element-90">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2 mt-1 flex-shrink-0" data-id="element-91" />
                <div data-id="element-92">
                  <p className="font-bold text-gray-800" data-id="element-93">
                    Jedna wizyta u psychologa
                  </p>
                  <p className="text-gray-600" data-id="element-94">(200-300 zł)</p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-95">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2 mt-1 flex-shrink-0" data-id="element-96" />
                <div data-id="element-97">
                  <p className="font-bold text-gray-800" data-id="element-98">
                    Pudełko tabletek uspokajających
                  </p>
                  <p className="text-gray-600" data-id="element-99">(50-80 zł)</p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-100">
                <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2 mt-1 flex-shrink-0" data-id="element-101" />
                <div data-id="element-102">
                  <p className="font-bold text-gray-800" data-id="element-103">
                    Jeden dzień zwolnienia, kiedy w końcu się rozchorujesz z
                    przemęczenia
                  </p>
                  <p className="text-gray-600" data-id="element-104">(stracone zarobki)</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-blue-50 rounded-lg p-6 my-8" data-id="element-105">
            <h3 className="text-xl font-bold text-gray-800 mb-6 text-center" data-id="element-106">
              Czy to naprawdę działa? Oto dowody:
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-107">
              W ciągu ostatnich 6 miesięcy e-book "Nie Zapomnij o Sobie" pobrało
              już 2,847 kobiet. Oto co piszą:
            </p>
            <div className="space-y-4 my-6" data-id="element-108">
              <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-109">
                <div className="flex mb-2" data-id="element-110">
                  <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80" alt="Magda" className="w-10 h-10 rounded-full mr-3" data-id="element-111" />
                  <div data-id="element-112">
                    <p className="font-bold text-gray-800" data-id="element-113">Magda, 39 lat</p>
                    <div className="flex" data-id="element-114">
                      <CheckCircleIcon className="h-4 w-4 text-green-600 mr-1" data-id="element-115" />
                      <p className="text-xs text-green-600" data-id="element-116">
                        Zweryfikowany zakup
                      </p>
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 italic" data-id="element-117">
                  "Przestałam krzyczeć na dzieci. Po 3 tygodniach praktyki czuję
                  się jak nowa osoba."
                </p>
              </div>
              <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-118">
                <div className="flex mb-2" data-id="element-119">
                  <img src="https://images.unsplash.com/photo-1554151228-14d9def656e4?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80" alt="Anna" className="w-10 h-10 rounded-full mr-3" data-id="element-120" />
                  <div data-id="element-121">
                    <p className="font-bold text-gray-800" data-id="element-122">Anna, 44 lata</p>
                    <div className="flex" data-id="element-123">
                      <CheckCircleIcon className="h-4 w-4 text-green-600 mr-1" data-id="element-124" />
                      <p className="text-xs text-green-600" data-id="element-125">
                        Zweryfikowany zakup
                      </p>
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 italic" data-id="element-126">
                  "Pierwszy raz od 5 lat poszłam sama na kawę. Bez wyrzutów
                  sumienia."
                </p>
              </div>
              <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-127">
                <div className="flex mb-2" data-id="element-128">
                  <img src="https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?ixlib=rb-1.2.1&auto=format&fit=crop&w=100&q=80" alt="Ewa" className="w-10 h-10 rounded-full mr-3" data-id="element-129" />
                  <div data-id="element-130">
                    <p className="font-bold text-gray-800" data-id="element-131">Ewa, 41 lat</p>
                    <div className="flex" data-id="element-132">
                      <CheckCircleIcon className="h-4 w-4 text-green-600 mr-1" data-id="element-133" />
                      <p className="text-xs text-green-600" data-id="element-134">
                        Zweryfikowany zakup
                      </p>
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 italic" data-id="element-135">
                  "Mąż zauważył, że jestem spokojna. To najlepsza inwestycja w
                  siebie, jaką zrobiłam."
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 my-8" data-id="element-136">
              <div className="bg-white p-4 rounded-lg shadow-sm text-center" data-id="element-137">
                <div className="text-3xl font-bold text-pink-600 mb-2" data-id="element-138">94%</div>
                <p className="text-gray-700 text-sm" data-id="element-139">
                  kobiet odczuwa poprawę już po pierwszym tygodniu
                </p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow-sm text-center" data-id="element-140">
                <div className="text-3xl font-bold text-pink-600 mb-2" data-id="element-141">87%</div>
                <p className="text-gray-700 text-sm" data-id="element-142">
                  kobiet stosuje metodę regularnie po miesiącu
                </p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow-sm text-center" data-id="element-143">
                <div className="text-3xl font-bold text-pink-600 mb-2" data-id="element-144">91%</div>
                <p className="text-gray-700 text-sm" data-id="element-145">
                  kobiet poleca e-book innym
                </p>
              </div>
            </div>
          </div>
          <div className="text-center my-8" data-id="element-146">
            <h3 className="text-xl font-bold text-gray-800 mb-6" data-id="element-147">
              Decyzja należy do Ciebie
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-148">
              Możesz zamknąć tę stronę i wrócić do swojego życia. Jutro znów
              będziesz biegać między obowiązkami, znów poczujesz tę gulę w
              gardle, znów będziesz się zastanawiać, jak długo jeszcze dasz
              radę.
            </p>
            <p className="text-gray-700 mb-6" data-id="element-149">
              Albo możesz dać sobie szansę. Tak jak ja dałam sobie tamtej nocy,
              niewypana i zdesperowana.
            </p>
            <p className="text-gray-700 mb-6" data-id="element-150">
              E-book "Nie Zapomnij o Sobie" czeka. Nie obiecuje cudów. Obiecuje
              coś znacznie cenniejszego - drogę powrotną do siebie.
            </p>
            <p className="text-gray-700 mb-4" data-id="element-151">
              Bo wiesz co odkryłam po tych trzech miesiącach? Że kiedy
              przestałam być tylko funkcją dla innych, stałam się lepszą mamą,
              lepszą córką, lepszą żoną.
            </p>
            <p className="text-gray-700 font-bold mb-8" data-id="element-152">
              Ale przede wszystkim - znów stałam się sobą.
            </p>
            <p className="text-gray-700 font-bold mb-8" data-id="element-153">I Ty też możesz.</p>
            <a href="https://veiramode.com/products/nie-zapomnij-o-sobie-ebook" className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-bold py-4 px-10 rounded-lg text-xl shadow-lg transform hover:scale-105 transition-all" data-id="element-154">
              ZAMÓW E-BOOK TERAZ - TYLKO 27,99 ZŁ
            </a>
            <div className="mt-4 text-sm text-gray-600" data-id="element-155">
              <p data-id="element-156">✅ Natychmiastowy dostęp po płatności</p>
              <p data-id="element-157">✅ Format PDF - czytasz na telefonie, tablecie, komputerze</p>
              <p data-id="element-158">✅ Kompletny protokół 15-minutowej regeneracji</p>
              <p data-id="element-159">✅ Plan 21-dniowy na wprowadzenie zmian</p>
            </div>
          </div>
          <div className="bg-gray-50 border-l-4 border-gray-300 p-4 mt-8" data-id="element-160">
            <p className="text-gray-700 mb-2" data-id="element-161">
              <span className="font-bold" data-id="element-162">P.S.</span> Wiesz, co powiedziała mi
              wczoraj mama podczas jednego ze swoich "jaśniejszych" momentów?
            </p>
            <p className="text-gray-700 italic" data-id="element-163">
              "Kasiu, dobrze, że już nie jesteś taka smutna."
            </p>
            <p className="text-gray-700 mt-2" data-id="element-164">
              Nawet ona, w swojej chorobie, zauważyła różnicę. To chyba
              najlepszy dowód, że te 15 minut naprawdę działa.
            </p>
          </div>
          <div className="bg-gray-50 border-l-4 border-gray-300 p-4 mt-4" data-id="element-165">
            <p className="text-gray-700" data-id="element-166">
              <span className="font-bold" data-id="element-167">P.P.S.</span> Jeśli wahasz się -
              pamiętaj: to mniej niż wydajesz na kawę w tydzień. A może zmienić
              Twoje życie na zawsze.
            </p>
          </div>
        </div>
      </div>
    </section>;
};